import React, { Suspense, lazy } from "react";
import Loader from "../Loader";

// A rich text editor is an admin's tool: it appears behind a sign-in, on a
// form, usually behind an "edit" button as well. Every visitor was paying for
// it on first load regardless - including the anonymous one reading an event
// page. Loading it here, when an editor is actually rendered, takes it out of
// everybody else's download.
//
// The call sites are unchanged apart from dropping `editor={ClassicEditor}`,
// which now lives with the editor itself.
const CKEditorClassic = lazy(() => import("./CKEditorClassic"));

const CKEditor = (props) => (
  <Suspense fallback={<Loader />}>
    <CKEditorClassic {...props} />
  </Suspense>
);

export default CKEditor;
